export default __webpack_public_path__ + "static/media/about-coding.d9dcdd41.jpg";